const CONSTANTS = {
  DURATION_IN_SEC: {
    DAY: 518400,
  },
  COLOR: {
    OBSOLETE_REPORT: "#999",
    DIRTY: "#fe5b51",
    PRETTY_DIRTY: "#ffc75f",
    PRETTY_CLEAN: "navy",
    CLEAN: "#1fc055",
  },
  REPORT_SCORE: {
    OBSOLETE: 24,
    DIRTY: 34,
    PRETTY_DIRTY: 40,
    PRETTY_CLEAN: 48,
    CLEAN: 60,
  },
  REPORTER_SCORE: {
    DID_NOT_CLEAN: 0,
    CLEANED_A_LITTLE: 1,
    CLEANED_SOME: 5,
    CLEANED: 20,
  },
};

function titleByScore(score) {
  let title = "מצוחצח";
  if (score <= CONSTANTS.REPORT_SCORE.PRETTY_CLEAN) {
    title = "די נקי";

    if (score <= CONSTANTS.REPORT_SCORE.PRETTY_DIRTY) {
      title = "די מלוכלך";
      if (score <= CONSTANTS.REPORT_SCORE.DIRTY) {
        title = "מלוכלך";
        if (score <= CONSTANTS.REPORT_SCORE.OBSOLETE) {
          title = "אין דיווח עדכני";
        }
      }
    }
  }
  return title;
}

function colorByScore(score) {
  let color = CONSTANTS.COLOR.CLEAN;
  if (score <= CONSTANTS.REPORT_SCORE.PRETTY_CLEAN) {
    color = CONSTANTS.COLOR.PRETTY_CLEAN;

    if (score <= CONSTANTS.REPORT_SCORE.PRETTY_DIRTY) {
      color = CONSTANTS.COLOR.PRETTY_DIRTY;
      if (score <= CONSTANTS.REPORT_SCORE.DIRTY) {
        color = CONSTANTS.COLOR.DIRTY;
        if (score <= CONSTANTS.REPORT_SCORE.OBSOLETE) {
          color = CONSTANTS.COLOR.OBSOLETE_REPORT;
        }
      }
    }
  }
  return color;
}



export { CONSTANTS, colorByScore, titleByScore };
